import React from 'react';

import Avatar from './Avatar';

function AvatarContainer({
  src,
  order,
  group,
  badge,
  showBadge,
  border,
  colorWithBadge,
  color,
  onClick,
  size,
  defaultValue,
}) {
  return (
    <Avatar
      img={src}
      defaultValue={defaultValue}
      order={order}
      group={group}
      badge={badge}
      showBadge={showBadge}
      border={border}
      colorWithBadge={colorWithBadge}
      color={color}
      onClick={onClick}
      size={size}
    />
  );
}
export default AvatarContainer;
